var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$task.hasResellerOrigins)?_c('b-notification',{staticClass:"has-padding-75 is-size-7",attrs:{"closable":false,"type":"is-warning"}},[_c('p',[_c('b-icon',{attrs:{"icon":"exclamation-triangle","size":"is-small"}}),_vm._v(" This task is linked to a reseller's account – avoid any references to 'Fixed' in this thread. ")],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }